import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { some } from 'lodash-es';

export interface FilterOptions {
  id?: number | string;
  name: string;
  count?: number;
  isChecked?: boolean;
  isDisabled?: boolean;
}

@Component({
    selector: 'app-options-dropdown',
    templateUrl: './options-dropdown.component.html',
    styleUrls: ['./options-dropdown.component.scss'],
    standalone: false
})
export class OptionsDropdownComponent implements OnInit {
  @Input() buttonName = 'Dropdown Button';
  @Input() filterOptions: FilterOptions[] = [];
  @Output() optionChangeCallback = new EventEmitter<FilterOptions>();
  isAnyOptionsSelected = false;

  ngOnInit(): void {
    this.filterOptions.map((option) => {
      if (!option.isChecked) {
        option.isChecked = false;
      }
      if (!option.isDisabled) {
        option.isDisabled = false;
      }
      return option;
    });

    this.isAnyOptionsSelected = some(this.filterOptions, ['isChecked', true]);
  }

  getDisabledClass(isDisabled: boolean | undefined): string {
    const isDisabledClass = !!isDisabled ? 'check-disabled' : '';
    return isDisabledClass;
  }

  onOptionChange(event: any, option: FilterOptions) {
    option.isChecked = event.target.checked;
    this.optionChangeCallback.emit(option);
    this.isAnyOptionsSelected = some(this.filterOptions, ['isChecked', true]);
  }
}
